import { render, staticRenderFns } from "./reference-toggle.vue?vue&type=template&id=c70bd3e8&"
import script from "./reference-toggle.vue?vue&type=script&lang=js&"
export * from "./reference-toggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports